import { graphql, useStaticQuery } from 'gatsby';

/**
 * Получаю список категорий
 * @param callback
 * @returns {*}
 */
export default ({ children }) => {
  let data = useStaticQuery(graphql`
    {
      allSponsorsJson(limit: 1000) {
        edges {
          node {
            fields {
              id
            }
            weight
            link
            title
          }
        }
      }
    }
  `);

  data = data.allSponsorsJson.edges.map(({ node }) => ({
    id: node.fields.id,
    weight: node.weight,
    link: node.link,
    title: node.title,
  }));

  return children(data);
};
